<script setup lang="ts">
</script>

<template>
  <div class="loading-overlay">
    <div class="spinner-ring">
      <div class="ring"></div>
      <div class="ring ring-inner"></div>
    </div>
    <p class="loading-text">正在加载...</p>
  </div>
</template>

<style scoped>
.loading-overlay {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  gap: 24px;
}

.spinner-ring {
  position: relative;
  width: 48px;
  height: 48px;
}

.ring {
  position: absolute;
  inset: 0;
  border: 3px solid var(--border-color);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.ring-inner {
  inset: 8px;
  border-width: 2px;
  border-top-color: #8b5cf6;
  animation-direction: reverse;
  animation-duration: 1.2s;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.loading-text {
  color: var(--text-muted);
  font-size: 14px;
  animation: pulse 2s ease-in-out infinite;
}
</style>
